<template>
  <VApp>
    <RouterView />
  </VApp>
</template>

<script setup>
  import { defineComponent } from "vue";

  defineComponent({
    name: "App",
  });
</script>
